exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.is-active .al img {\n    border: 1px solid #fff;\n    filter: grayscale(0%);\n}\n.al img {\n    border: 1px solid transparent;\n    filter: grayscale(100%);\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/components/carousel/examples/ExGallery.vue"],"names":[],"mappings":";AACA;IACI,uBAAuB;IACvB,sBAAsB;CACzB;AACD;IACI,8BAA8B;IAC9B,wBAAwB;CAC3B","file":"ExGallery.vue","sourcesContent":["\n.is-active .al img {\n    border: 1px solid #fff;\n    filter: grayscale(0%);\n}\n.al img {\n    border: 1px solid transparent;\n    filter: grayscale(100%);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48ed9866","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./docs/pages/components/carousel/examples/ExGallery.vue
// module id = 993
// module chunks = 3 48